import { render, staticRenderFns } from "./menuGerencia.vue?vue&type=template&id=d4d0a8bc&scoped=true"
import script from "./menuGerencia.vue?vue&type=script&lang=js"
export * from "./menuGerencia.vue?vue&type=script&lang=js"
import style0 from "./menuGerencia.vue?vue&type=style&index=0&id=d4d0a8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d0a8bc",
  null
  
)

export default component.exports